export default __webpack_public_path__ + "static/banner1-a788daf075cd495daa4c4e40e1e70194.png";